import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import moment from "moment";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/RightArrowIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import MobileView from "./MobileView";
import MilestoneModal from "../../../../components/MilestoneModal";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

export default function Milestones({
  details,
  getProjectDetails,
  isMobile,
  styles,
}) {
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  // Check if device is mobile
  const isMobileDevice = isMobile;

  // Get styles with mobile parameter
  const componentStyles = styles || styles(isMobileDevice);

  const handleClick = (item) => {
    console.log("item", item, id);
    navigate(`/new-create-proposal/${id}/milestone/${item.id}`, {
      state: {
        milestoneData: item,
        project: details,
        styles: componentStyles,
      },
    });
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  if (isMobile) {
    return (
      <MobileView
        details={details}
        getProjectDetails={getProjectDetails}
        handleClick={handleClick}
      />
    );
  }

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "87vh",
          marginTop: "2vh",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Milestone</StyledTableCell>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
              <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Amount ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
              {/* <StyledTableCell>Status</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.milestone?.map((item, idx) => (
              <>
                <TableRow key={item.id}>
                  <StyledTableCell
                    onClick={() => handleClick(item)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        color: "blue",
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Box
                        component="img"
                        src={
                          item?.milestone_image
                            ? item?.milestone_image?.path
                            : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                        }
                        alt="Project Icon"
                        sx={{
                          width: 45,
                          height: 45,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                      <span>{item?.milestone_name}</span>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Box display="flex" alignItems="center" gap="5px">
                      <Box display="flex" alignItems="center">
                        {item?.tags === "Design" ? (
                          <NewDesignIcon />
                        ) : (
                          <NewRenovationIcon />
                        )}
                      </Box>
                      <Box color="#949DAA">{item?.tags}</Box>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    <p style={componentStyles.greyRow}>
                      {moment(item?.start_date).format("MMM DD, YYYY")}
                    </p>
                  </StyledTableCell>
                  <StyledTableCell>
                    <p style={componentStyles.greyRow}>
                      {moment(item?.end_date).format("MMM DD, YYYY")}
                    </p>
                  </StyledTableCell>
                  <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                    {`${formattedAmountWithoutAed(item?.amount)}`}
                  </StyledTableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedMilestone && (
        <MilestoneModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedMilestone={selectedMilestone}
          isEdit={Object.keys(selectedMilestone).length !== 0}
          milestones={details?.milestone}
          proposalId={id}
          getProjectDetails={getProjectDetails}
        />
      )}
    </>
  );
}
